import { Component, Input } from '@angular/core';
import { SubmittedConsultantInfo } from '@core/store/start-now-app/start-now-app-state-models';

@Component({
  selector: 'app-organizer-info-card',
  templateUrl: './organizer-info-card.component.html',
  styleUrls: ['./organizer-info-card.component.scss'],
})
export class OrganizerInfoCardComponent {
  constructor() {}
  @Input() submittedConsultant: SubmittedConsultantInfo;
}
